import { Tolgee, DevTools } from "@tolgee/react";
import { FormatIcu } from "@tolgee/format-icu";

// Detect language: saved preference → browser locale → fallback "ru"
const savedLang = localStorage.getItem("postcash_lang");
const browserLang = navigator.language?.toLowerCase().startsWith("ru") ? "ru" : "en";
const initialLang = savedLang || browserLang;

export const tolgee = Tolgee()
  .use(FormatIcu())
  .use(import.meta.env.DEV ? DevTools() : undefined)
  .init({
    language: initialLang,
    availableLanguages: ["en", "ru", "az", "it", "uz", "tk", "ky", "kk"],
    defaultLanguage: "ru",
    ...(import.meta.env.DEV && import.meta.env.VITE_TOLGEE_API_KEY
      ? {
          apiUrl: import.meta.env.VITE_TOLGEE_API_URL || "https://app.tolgee.io",
          apiKey: import.meta.env.VITE_TOLGEE_API_KEY,
        }
      : {}),
    staticData: {
      en: () => import("./en.json"),
      ru: () => import("./ru.json"),
      az: () => import("./az.json"),
      it: () => import("./it.json"),
      uz: () => import("./uz.json"),
      tk: () => import("./tk.json"),
      ky: () => import("./ky.json"),
      kk: () => import("./kk.json"),
    },
  });
